export default "__VITE_ASSET__a3773594__"